(function () {
  function initSection(section) {
    var tabs = Array.from(section.querySelectorAll('.bm-bst-tab-btn'));
    var outers = Array.from(section.querySelectorAll('.bm-bst-cards-outer'));
    var indicator = section.querySelector('.bm-bst-pill-indicator');
    var pillWrap = section.querySelector('.bm-bst-pill-wrap');

    if (!tabs.length || !outers.length) return;
    if (tabs.length !== outers.length) {
      console.warn('[BM BST] Tab/outer count mismatch:', tabs.length, outers.length);
      return;
    }

    // ── INDICATOR ──
    function positionIndicator(index, animate) {
      if (!indicator || !pillWrap) return;
      var btn = tabs[index];
      var pillLeft = pillWrap.getBoundingClientRect().left;
      var btnRect = btn.getBoundingClientRect();
      var x = btnRect.left - pillLeft;
      var w = btnRect.width;
      if (!animate) {
        indicator.style.transition = 'none';
      }
      indicator.style.width = w + 'px';
      indicator.style.transform = 'translateX(' + x + 'px)';
      if (!animate) {
        indicator.getBoundingClientRect(); // force reflow
        indicator.style.transition = '';
      }
    }

    // ── ARROW UPDATE ──
    function updateArrows(outer) {
      var grid = outer.querySelector('.bm-bst-cards-grid');
      var arrowLeft = outer.querySelector('.bm-bst-arrow--left');
      var arrowRight = outer.querySelector('.bm-bst-arrow--right');
      if (!grid) return;
      var atStart = grid.scrollLeft < 1;
      var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 8;
      if (arrowLeft) {
        if (atStart) arrowLeft.classList.add('is-hidden');
        else arrowLeft.classList.remove('is-hidden');
      }
      if (arrowRight) {
        if (atEnd) arrowRight.classList.add('is-hidden');
        else arrowRight.classList.remove('is-hidden');
      }
    }

    // ── ARROW INIT ──
    function initArrows(outer) {
      var grid = outer.querySelector('.bm-bst-cards-grid');
      var arrowLeft = outer.querySelector('.bm-bst-arrow--left');
      var arrowRight = outer.querySelector('.bm-bst-arrow--right');
      if (!grid) return;

      updateArrows(outer);

      function getCardWidth() {
        var card = grid.querySelector('.bm-bst-card-item');
        return card ? card.offsetWidth + 12 : grid.clientWidth / 2;
      }

      if (arrowRight) {
        arrowRight.addEventListener('click', function () {
          grid.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
        });
      }
      if (arrowLeft) {
        arrowLeft.addEventListener('click', function () {
          grid.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
        });
      }
      grid.addEventListener('scroll', function () { updateArrows(outer); });
    }

    // ── TAB ACTIVATION ──
    function activateTab(index) {

       // ── ANIMATE ALL TABS ──
  tabs.forEach(function (btn, i) {
    btn.classList.remove('is-animating');
    btn.style.setProperty('--wave-i', i); // for Option D wave stagger
    void btn.offsetWidth; // force reflow to restart animation
    btn.classList.add('is-animating');
    // Clean up after animation completes
    btn.addEventListener('animationend', function () {
      btn.classList.remove('is-animating');
    }, { once: true });
  });
      
      tabs.forEach(function (btn) { btn.classList.remove('active'); });
      outers.forEach(function (outer) { outer.style.display = 'none'; });
      tabs[index].classList.add('active');
      if (outers[index]) {
        outers[index].style.display = 'block';
        var grid = outers[index].querySelector('.bm-bst-cards-grid');
        if (grid) grid.scrollLeft = 0;
        updateArrows(outers[index]);
      }
      positionIndicator(index, true);
    }

    // ── INIT ──
    function init() {
      // Ensure first tab/outer visible, rest hidden
      tabs.forEach(function (btn, i) {
        if (i === 0) btn.classList.add('active');
        else btn.classList.remove('active');
      });
      outers.forEach(function (outer, i) {
        outer.style.display = i === 0 ? 'block' : 'none';
        initArrows(outer);
      });

      // Position indicator after layout is fully painted
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          positionIndicator(0, false);
          if (indicator) indicator.classList.add('is-ready');
          // Re-check arrows after layout settles
          setTimeout(function () {
            outers.forEach(function (outer) { updateArrows(outer); });
          }, 100);
        });
      });
    }

    // ── TAB CLICK ──
    tabs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { activateTab(i); });
    });

    // ── RESIZE ──
    window.addEventListener('resize', function () {
      var activeIndex = tabs.findIndex(function (b) {
        return b.classList.contains('active');
      });
      if (activeIndex >= 0) positionIndicator(activeIndex, false);
    });

    // ── AJAX ADD TO BOWL ──
    section.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var variantId = form.querySelector('input[name="id"]').value;
        var btn = form.querySelector('button[type="submit"]');
        var originalText = btn.textContent;
        btn.textContent = 'Adding...';
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            btn.textContent = 'Added! 🐾';
            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 2000);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('theme:cart:open'));
          })
          .catch(function () {
            btn.textContent = 'Try again';
            btn.disabled = false;
          });
      });
    });

    // ── RUN ──
    init();
  }

  // ── BOOT ──
  function boot() {
    document.querySelectorAll('.bm-bst-section').forEach(function (section) {
      initSection(section);
    });
  }

  // Run after full page load (fixes CSS 3s delay + indicator timing)
  if (document.readyState === 'complete') {
    boot();
  } else {
    window.addEventListener('load', boot);
  }

  // Shopify theme editor live reload support
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.bm-bst-section');
    if (section) initSection(section);
  });
})();
